module.exports = __webpack_public_path__ + "img/hardwareOpen6.f58f57f2.png";